import React, { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { Alert, Container } from 'react-bootstrap'
import { fetchIndividualEstimate } from 'application/actions/individualEstimateActions'
import { fetchIndividualEstimate as fetchIndividualEstimateConsultant } from 'application/actions/consultantIndividualEstimateActions'
import withLocation from '../../withLocation'
import { ResetProceedEstimateErrorMessage } from 'application/actions/proceedEstimateActions'
import Layout from 'application/layout'
import ConsultantLayout from 'application/consultantLayout'
import { httpVerbConstants } from 'application/constants/actionTypes'
import { useLocation } from 'react-router-dom'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
  checkConsultant,
} from 'application/helpers'
import EstimateDetails from './estimateDetails'
import { Image as MaxxiaImage } from 'Maxxia/images'
import { Image as RemServImage } from 'RemServ/images'
import * as E from '../notFoundPageElements'

const IndividualEstimateScreen = ({
  match,
  accessToken,
  isAuthenticated,
  isFetching,
  opportunityId,
  dispatch,
  carData,
  summaryData,
  endOfLeaseData,
  runningData,
  financialInclusionData,
  bannerData,
  isEstimateValid,
  estimate,
  errorMessage,
  applicationRoles,
  releaseData,
}) => {
  let headers = { accessToken: accessToken }
  const { isConsultant } = applicationRoles
  const userEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:estimates:view' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:estimates:view' },
        },
      })
    }
  }
  const consultantEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:consultant:estimates:view' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:consultant:estimates:view' },
        },
      })
    }
  }
  const customEvents = () => {
    checkConsultant() ? consultantEvents() : userEvents()
  }
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const urlestimateID = location.pathname.substring(proposalIndex + 1)

  const callUser = () => {
    dispatch(
      fetchIndividualEstimate(
        opportunityId,
        match.params.estimateId,
        false,
        true
      )
    )
    dispatch(ResetProceedEstimateErrorMessage())
  }
  const callConsultant = () => {
    dispatch(
      fetchIndividualEstimateConsultant(
        opportunityId,
        match.params.estimateId,
        headers,
        httpVerbConstants.HTTP_GET
      )
    )
    dispatch(ResetProceedEstimateErrorMessage())
  }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      checkConsultant() ? callConsultant() : callUser()
      customEvents()
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'view estimate details',
          label: 'view estimate details',
        },
      },
    })
    let notificationElement = document.getElementById('notification')
    if (notificationElement !== undefined && notificationElement !== null) {
      if (isEstimateValid) {
        document.getElementById('notification').style.display = 'none'
      } else {
        document.getElementById('notification').style.display = 'block'
      }
    }
  }, [])

  const isError = errorMessage || false

  let userEmployer = useSelector((state) => state.user.employer)
  var novatedLeaseData = {
    proposalEstimate: estimate,
    userEmployer: userEmployer,
  }

  return isError ? (
    <>
      { global.config.isBrandMX && <E.MaxxiaTriangleDiv />}
      { global.config.isBrandRS && <E.RemServTriangleDiv />}
      <Container className="notfound-container p-5 mb-5 bg-white shadow-sm">
        <Alert variant="danger">{errorMessage}</Alert>
      </Container>
    </>
  ) : isFetching ? (
    <div className="mt-5 mb-5 d-flex justify-content-center">
      {global.config.isBrandMX && <MaxxiaImage imageName={'Loader'} alt="" />}
      {global.config.isBrandRS && <RemServImage imageName={'Loader'} alt="" />}
    </div>
  ) : isConsultant ? (
    <ConsultantLayout>
      <EstimateDetails
        isConsultant
        bannerData={bannerData}
        carData={carData}
        summaryData={summaryData}
        runningData={runningData}
        financialInclusionData={financialInclusionData}
        endOfLeaseData={endOfLeaseData}
        releaseData={releaseData}
        isEstimateValid={isEstimateValid}
        novatedLeaseData={novatedLeaseData}
      />
    </ConsultantLayout>
  ) : (
    <Layout>
      <EstimateDetails
        bannerData={bannerData}
        carData={carData}
        summaryData={summaryData}
        runningData={runningData}
        financialInclusionData={financialInclusionData}
        endOfLeaseData={endOfLeaseData}
        releaseData={releaseData}
        isEstimateValid={isEstimateValid}
        novatedLeaseData={novatedLeaseData}
      />
    </Layout>
  )
}

function mapStateToProps(state, ownProps) {
  const applicationRoles = state.applicationRoles
  const accessToken = state.auth.accessToken
  const isAuthenticated = checkConsultant()
    ? state.auth.isAuthenticated
    : state.authentication.isAuthenticated
  const opportunityId = checkConsultant()
    ? state.opportunity.opportunityId
    : state.authentication.opportunityId
  const {
    firstName: userFirstName,
    employer: { payFrequency, employerGRS, grossAnnualSalary, name } = {},
  } = state.user

  const channel = state.opportunity.channel
  const leaseEndDate = state.opportunity.leaseEndDate
  const { firstName: consultantFirstName } = state.consultant
  const estimate = state.individualEstimate.estimate || {}
  const isExGST = employerGRS.gstExclusiveDeductionsCode === 'Yes'
  const isTaxShare = estimate.taxShare === 'Yes'
  const isGov = state.user.isGov && global.config.isBrandRS
  const brand = state.opportunity.brand
  const negativeEquityAmount =
    state.estimates &&
    state.estimates.tradeIn &&
    state.estimates.tradeIn.negativeEquityAmount
  const { isFetching } = state.individualEstimate
  const errorMessage = (
    (state.individualEstimate && state.individualEstimate.errorMessage) ||
    ''
  )
    .replace('500', '')
    .replace('400', '')
    .replace('404', '')
  const {
    //car
    vehicle = {},
    onRoadcost,
    priveawayPrice,
    amTotalExGST,
    tpoTotalExGST,
    basePriceNoVehicle,
    financeAmount,
    gstCreditClaimable,
    totalVehicleExGST,
    totalVehicleGST,
    totalVehicleValueExGST,
    luxuryCarTax,
    //summary
    leaseTermYears,
    leaseTerm,
    carRepaymentPerPayIncGST,
    carRepaymentPerPayExGST,
    totalPackagePerPayIncGST,
    totalPackagePerPayExGST,
    totalPackagePerPayExGSTTaxShare,
    runningCostsPerPayIncGST,
    runningCostsPerPayExGST,
    runningCostsPerPayExGSTTaxShare,
    savingsPerPay,
    outOfPocketPerPay,
    fuelBudget,
    electricityBudget,
    tyresBudget,
    incidentalsBudget,
    registrationBudget,
    scheduleMaintenanceBudget,
    roadsideAssistanceBudget,
    compInsRenewalBudget,
    takeHomePerPay,
    grossSalaryPerPay,
    preTaxPerPay,
    spPreTaxDeduction,
    otherPreTaxPerPay,
    preTaxDeduction,
    taxSharePerPay,
    spTaxShareDeduction,
    netSalaryPerPay,
    netSalaryPerAnnum,
    taxMedicarePerPay,
    spTaxAndMedicare,
    netIncomePerPay,
    spNetCashSalary,
    postTaxPerPay,
    specm,
    otherPostTaxPerPay,
    postTaxDeduction,
    spCashinhand,
    lifeOfLeaseTaxSaving,
    gstSavingsOnRunningCosts,
    //running
    kmPerAnnum,
    fuelPerPayExGST,
    fuelPerPayIncGST,
    electricityPerPayExGST,
    electricityPerPayIncGST,
    tyresPerPayExGST,
    tyresPerPayIncGST,
    roadsideAssist,
    roadsidePerPayExGST,
    roadsidePerPayIncGST,
    maintenancePerPayExGST,
    maintenancePerPayIncGST,
    incidentalsPerPayExGST,
    incidentalsPerPayIncGST,
    fuelPerAnnumExGST,
    fuelPerAnnumIncGST,
    electricityPerAnnumExGST,
    electricityPerAnnumIncGST,
    tyresPerAnnumExGST,
    tyresPerAnnumIncGST,
    roadsidePerAnnumExGST,
    roadsidePerAnnumIncGST,
    maintenancePerAnnumExGST,
    maintenancePerAnnumIncGST,
    incidentalsPerAnnumExGST,
    incidentalsPerAnnumIncGST,
    costsPerPayIncGST,
    costsPerPayExGST,
    regoInsPerPayExGST,
    regoInsPerPayIncGST,
    regoPerPayIncGST,
    regoPerAnnumIncGST,
    compInsPerPayExGST,
    compInsPerPayIncGST,
    compInsPerAnnumExGST,
    compInsPerAnnumIncGST,
    totalChargesPerPayExGST,
    totalChargesPerPayIncGST,
    totalChargesPerPayIncGSTTaxShare,
    totalChargesPerPayExGSTTaxShare,
    nlFeePerPayExGST,
    nlFeePerPayIncGST,
    spFeePerPayExGST,
    spFeePerPayIncGST,
    fbtPerPay,
    lcdaPerPay,
    erSharePerPay,
    gstOnECMPerPay,
    greenfleetPerPay,
    erAdminFeePerPay,
    nlFeePerAnnumExGST,
    nlFeePerAnnumIncGST,
    spFeePerAnnumExGST,
    spFeePerAnnumIncGST,
    fbtPerAnnum,
    lcdaPerAnnum,
    taxSavings, // erSharePerAnnum,
    gstOnECMPerAnnum,
    greenfleetPerAnnum,
    erAdminFeePerAnnum,
    fbtMethod,
    noOfTyresBudget,
    //finance
    compInsurance,
    mmsgDocumentFee,
    compInsurancePremium,
    leaseProtectionPremium,
    extendedWarrantyPremium,
    gapCoverPremium,
    rpcPremium,
    rpcProvider,
    leaseResidualAmountIncGST,
    residualPCT,
    annualRate,
    leaseProtection,
    rpc,
    extendedWarranty,
    extendedWarrantyProvider,
    gapCover,
    nlQuoteNumber,
    totalOnroads,
    totalExGSTNoVehicle,
    isValid,
    vehicleDescription,
    estimateId: id,
    vehicleType,
    financierEstablishmentFee,
    extendedWarrantyTerm,
    totalLeaseRunningCostsPerPayExGST,
    compInsuranceCommissionPerAnnumIncGST,
    gapCoverCommissionPerAnnumIncGST,
    vehicleFBTValue,
    brokeragePerAnnum,
    financierEstablishmentFeePerAnnum,
    isIndicativeProposal,
    compInsuranceCommissionExGST,
    compInsuranceCommGST,
    gapCoverCommissionExGST,
    gapCoverCommGST,
    rpcCommissionPerAnnumIncGST,
    rpcCommissionExGST,
    rpcCommGST,
    brokerage,
    currentNLOutOfPocketCostPerPay,
    extendedWarrantyCommGST,
    extendedWarrantyCommExGST,
    extendenWarrantyCommissionPerAnnumIncGST,
    leaseProtectionCommissionPerAnnumIncGST,
    leaseProtectionCommExGST,
    leaseProtectionCommGST,
    vehicleLeaseValue,
    productId,
    registrationFee,
    ctp,
    overTheCapMethod,
    compInsurancePremiumFinanced,
    compInsuranceProvider,
    fuelPricePerLitre,
    electricityCostPerKm,
    financierFeePerPay,
    monthlyRepaymentAmountIncGST,
    noPkgTaxAndMedicare,
    noPkgNetSalary,
    noPkgCashInHand1,
    totalSavingsITCsTaxVehicleGST,
    taxandMedicareSavingsLifeofLease,
    gstSavingsOnRunningCostsLifeofLease,

  } = estimate

  const { year, make, family } = vehicle

  const isEstimateValid = isValid

  const financialInclusionData = {
    ...vehicle,
    financeAmount,
    compInsurance,
    priveawayPrice,
    compInsurancePremium,
    leaseProtectionPremium,
    rpcPremium,
    rpcProvider,
    extendedWarrantyPremium,
    gapCoverPremium,
    annualRate,
    leaseTermYears,
    extendedWarrantyProvider,
    brand,
    consultantFirstName,
    userFirstName,
    stampDutyViaDisbursement: vehicle.stampDutyViaDisbursement,
    financierEstablishmentFee,
    negativeEquityAmount,
    displayInterest: employerGRS.displayInterestRateOnDigitalEstimate,
    extendedWarrantyTerm,
    registrationFee: vehicle.registrationFee,
    ctp: vehicle.ctp,
    stampDuty: vehicle.stampDuty,
    compInsurancePremiumFinanced,
    compInsuranceProvider,
  }

  const {
    vehicleAccessories = [],
    thirdPartyOption = { thirdPartyOptionLines: [] },
  } = vehicle

  const { thirdPartyOptionLines = [] } = thirdPartyOption

  const carData = {
    ...vehicle,
    luxuryCarTax: vehicle.id ? vehicle.luxuryCarTax : luxuryCarTax,
    brand,
    onRoadcost: vehicle.id ? totalOnroads : onRoadcost,
    priveawayPrice,
    amTotalExGST,
    tpoTotalExGST: vehicle.id ? tpoTotalExGST : 0,
    listedPrice: vehicle.id ? vehicle.basePrice : totalVehicleValueExGST,
    vehicleAccessoriesNames: vehicleAccessories
      ? vehicleAccessories.map((item) => item.name).join(', ')
      : null,
    accesoriesByYou: thirdPartyOptionLines
      ? thirdPartyOptionLines.map((item) => item.description).join(', ')
      : null,
    gstCreditClaimable,
    totalVehicleExGST,
    totalExGSTNoVehicle,
    totalVehicleGST: vehicle.id ? vehicle.totalVehicleGST : totalVehicleGST,
    vehicleId: vehicle.id,
    vehicleImage: vehicle.vehicleImage,
    vehicleDescription,
    id,
    opportunityId,
    vehicleType: vehicle.id ? vehicle.vehicleType : vehicleType,
    shadowPR: vehicle.shadowPR,
    spartaDetail: vehicle.shadowPR ? vehicle.spartaDetail : null,
    fuelType: vehicle.fuelType,
    payload: vehicle.payLoad == '0' ? null : vehicle.payLoad,
    cylinders: vehicle.vehicleCylinderConfig,
    retailPrice: vehicle.retailPrice,
    cO2EmissionsPerKM: vehicle.cO2EmissionsPerKM,
    isEvRebate: employerGRS.evRebateApplicable,
    evRebateValue: employerGRS.evRebateValue,
    evRebateTnCLink: employerGRS.evRebateLink,
    noPkgCashInHand1
  }

  const summaryData = {
    ...vehicle,
    brand,
    leaseTermYears,
    leaseTerm,
    payFrequency,
    annualRate,
    carRepaymentPerPay: isExGST
      ? carRepaymentPerPayExGST
      : carRepaymentPerPayIncGST,
    totalPackagePerPay: isExGST
      ? isTaxShare
        ? totalPackagePerPayExGSTTaxShare
        : totalPackagePerPayExGST
      : totalPackagePerPayIncGST,
    runningCostsPerPay: isExGST
      ? isTaxShare
        ? runningCostsPerPayExGSTTaxShare
        : runningCostsPerPayExGST
      : runningCostsPerPayIncGST,
    savingsPerPay,
    outOfPocketPerPay,
    fuelBudget,
    electricityBudget,
    tyresBudget,
    incidentalsBudget,
    registrationBudget,
    scheduleMaintenanceBudget,
    roadsideAssistanceBudget,
    roadsideAssist,
    compInsRenewalBudget,
    takeHomePerPay,
    grossSalaryPerPay,
    grossAnnualSalary,
    preTaxPerPay,
    spPreTaxDeduction,
    otherPreTaxPerPay,
    preTaxDeduction,
    taxSharePerPay,
    spTaxShareDeduction,
    netSalaryPerPay,
    netSalaryPerAnnum,
    taxMedicarePerPay,
    spTaxAndMedicare,
    netIncomePerPay,
    spNetCashSalary,
    postTaxPerPay,
    specm,
    otherPostTaxPerPay,
    postTaxDeduction,
    spCashinhand,
    lifeOfLeaseTaxSaving,
    leaseResidualAmountIncGST,
    userFirstName,
    consultantFirstName,
    vehicleDescription,
    opportunityId,
    vehicleId: vehicle.id,
    gstSavingsOnRunningCosts,
    displayInterest: employerGRS.displayInterestRateOnDigitalEstimate,
    fbtPerPay,
    fbtPerAnnum,
    productId,
    fbtMethod,
    vehicleFBTValue,
    overTheCapMethod,
    employerName: name,
    totalSavingsITCsTaxVehicleGST,
    taxandMedicareSavingsLifeofLease,
    gstSavingsOnRunningCostsLifeofLease,
    gstCreditClaimable
  }

  const runningData = {
    brand,
    kmPerAnnum,
    payFrequency,
    userFirstName,
    consultantFirstName,
    fuelPerPay: { exGST: fuelPerPayExGST, incGST: fuelPerPayIncGST },
    electricityPerPay: {
      exGST: electricityPerPayExGST,
      incGST: electricityPerPayIncGST,
    },
    tyresPerPay: { exGST: tyresPerPayExGST, incGST: tyresPerPayIncGST },
    roadsideAssist,
    roadsidePerPay: {
      exGST: roadsidePerPayExGST,
      incGST: roadsidePerPayIncGST,
    },
    maintenancePerPay: {
      exGST: maintenancePerPayExGST,
      incGST: maintenancePerPayIncGST,
    },
    incidentalsPerPay: {
      exGST: incidentalsPerPayExGST,
      incGST: incidentalsPerPayIncGST,
    },
    fuelPerAnnum: { exGST: fuelPerAnnumExGST, incGST: fuelPerAnnumIncGST },
    electricityPerAnnum: {
      exGST: electricityPerAnnumExGST,
      incGST: electricityPerAnnumIncGST,
    },
    tyresPerAnnum: { exGST: tyresPerAnnumExGST, incGST: tyresPerAnnumIncGST },
    roadsidePerAnnum: {
      exGST: roadsidePerAnnumExGST,
      incGST: roadsidePerAnnumIncGST,
    },
    maintenancePerAnnum: {
      exGST: maintenancePerAnnumExGST,
      incGST: maintenancePerAnnumIncGST,
    },
    incidentalsPerAnnum: {
      exGST: incidentalsPerAnnumExGST,
      incGST: incidentalsPerAnnumIncGST,
    },
    costsPerPay: isExGST ? costsPerPayExGST : costsPerPayIncGST,
    regoInsPerPay: isExGST ? regoInsPerPayExGST : regoInsPerPayIncGST,
    regoPerPay: regoPerPayIncGST,
    regoPerAnnum: regoPerAnnumIncGST,
    compInsPerPay: {
      exGST: compInsPerPayExGST,
      incGST: compInsPerPayIncGST,
    },
    compInsPerAnnum: {
      exGST: compInsPerAnnumExGST,
      incGST: compInsPerAnnumIncGST,
    },
    totalChargesPerPay: isExGST
      ? isTaxShare
        ? totalChargesPerPayExGSTTaxShare
        : totalChargesPerPayExGST
      : isTaxShare
      ? totalChargesPerPayIncGSTTaxShare
      : totalChargesPerPayIncGST,
    nlFeePerPay: {
      exGST: nlFeePerPayExGST,
      incGST: nlFeePerPayIncGST,
    },
    spFeePerPay: {
      exGST: spFeePerPayExGST,
      incGST: spFeePerPayIncGST,
    },
    fbtPerPay,
    lcdaPerPay,
    erSharePerPay,
    gstOnECMPerPay,
    greenfleetPerPay,
    erAdminFeePerPay,
    nlFeePerAnnum: {
      exGST: nlFeePerAnnumExGST,
      incGST: nlFeePerAnnumIncGST,
    },
    spFeePerAnnum: {
      exGST: spFeePerAnnumExGST,
      incGST: spFeePerAnnumIncGST,
    },
    fbtPerAnnum,
    lcdaPerAnnum,
    erSharePerAnnum: taxSavings,
    gstOnECMPerAnnum,
    greenfleetPerAnnum,
    erAdminFeePerAnnum,
    isExGST,
    fbtMethod,
    noOfTyresBudget,
    isTaxShare,
    overTheCapMethod,
    compInsuranceProvider,
    vehicle: { ...vehicle },
    isGov,
    fuelPricePerLitre,
    electricityCostPerKm,
    leaseTermYears,
    compInsurancePremium,
    compInsurancePremiumFinanced
  }

  const bannerData = {
    nlQuoteNumber,
    userFirstName,
    brand,
    isConsultant: state.applicationRoles.isConsultant,
  }

  const endOfLeaseData = {
    ...vehicle,
    leaseResidualAmountIncGST,
    brand:
      state.opportunity.brand.toLowerCase() === 'remserv'
        ? 'RemServ'
        : 'Maxxia',
    userFirstName,
    consultantFirstName,
    year,
    make,
    family,
    vehicleId: vehicle.id,
    vehicleDescription,
    payFrequency,
    residualPCT,
    opportunityId,
    showRecommendedRetailPrice:
      vehicle.retailPrice &&
      priveawayPrice &&
      vehicle.retailPrice > priveawayPrice,
    annualRate,
    fbtMethod,
    leaseTerm,
    kmPerAnnum,
    nlFeePerPay: isExGST ? nlFeePerPayExGST : nlFeePerPayIncGST,
    financeAmount,
    carRepaymentPerPayExGST,
    totalLeaseRunningCostsPerPayExGST,
    compInsuranceCommissionPerAnnumIncGST,
    gapCoverCommissionPerAnnumIncGST,
    vehicleFBTValue,
    financierEstablishmentFeePerAnnum,
    rpcCommissionPerAnnumIncGST,
    brokeragePerAnnum,
    isIndicativeProposal,
    nlFeePerAnnumIncGST:
      nlFeePerAnnumIncGST !== null ? nlFeePerAnnumIncGST : 275,
    financierEstablishmentFee:
      financierEstablishmentFee !== null ? financierEstablishmentFee : 431.82,
    spFeePerAnnumIncGST:
      spFeePerAnnumIncGST !== null ? spFeePerAnnumIncGST : 325,
    compInsuranceCommissionExGST,
    compInsuranceCommGST,
    gapCoverCommissionExGST,
    gapCoverCommGST,
    rpcCommissionExGST,
    rpcCommGST,
    financierEstablishmentFee,
    brokerage,
    extendedWarrantyCommGST,
    extendedWarrantyCommExGST,
    extendenWarrantyCommissionPerAnnumIncGST,
    leaseProtectionCommissionPerAnnumIncGST,
    leaseProtectionCommExGST,
    leaseProtectionCommGST,
    procurementFee: vehicle.procurementFee,
    vehicleFBTValue,
    nlFeePerPayExGST,
    isGov,
    rpcProvider,
    extendedWarrantyProvider,
    financierFeePerPay,
    monthlyRepaymentAmountIncGST,
    fuelPricePerLitre,
    vehicleAccessoriesNames: vehicleAccessories
      ? vehicleAccessories.map((item) => item.name).join(', ')
      : null,
    accesoriesByYou: thirdPartyOptionLines
      ? thirdPartyOptionLines.map((item) => item.description).join(', ')
      : null,
    specm:specm,
    preTaxPerPay
  }

  const releaseData = {
    isRelease: false,
    /*uncomment this code when release is enabled: channel && channel.toLowerCase() == 're-lease',*/
    isExistingCar: vehicle.vehicleType == 'Residual Release',
    userFirstName,
    oldOutOfPocketPerPay: currentNLOutOfPocketCostPerPay,
    outOfPocketPerPay,
    leaseEndDate,
  }

  return {
    accessToken,
    isAuthenticated,
    isFetching,
    opportunityId,
    carData,
    summaryData,
    endOfLeaseData,
    runningData,
    financialInclusionData,
    bannerData,
    isEstimateValid,
    estimate,
    errorMessage,
    applicationRoles,
    releaseData,
    brand,
  }
}

export default connect(mapStateToProps)(withLocation(IndividualEstimateScreen))
